import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Box, Button, Typography, Stack } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { v4 as uuidv4 } from "uuid";
import imageCompression from "browser-image-compression";
import moment from "moment";
import GoglobalStoreage from "goglobalstoragenpm";
//Srcs
import "./cropstudentbook.scss";

export default function CropImageStuBookFile({
  openCrop,
  setProgress,
  setStatusProgress,
  setOpenCrop,
  photoURL,
  setPhotoURL,
  setImageFile,
  setProfileHook,
}) {
  const [loading, setLoading] = useState(false);

  let goglobalStoreage = new GoglobalStoreage();
  useEffect(() => {
    goglobalStoreage.createClient(
      "66c5b516b8a3342a9912aad8",
      "2DFdT3SELA6xBaEmfzntmHggADTzEsDwBAhyn5u77sY"
    );
  }, []);

  const newDate = moment(new Date()).format("MMdYYYY");

  // Upload and compress image
  const uploadImage = async (file) => {
    if (!file) return;

    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    const compressedFile = await imageCompression(file, options);
    let newName = `${uuidv4()}${newDate}${file.name.split(".").pop()}`;
    var newFile = new File([compressedFile], `${newName}.png`, {
      type: "image/png",
    });

    goglobalStoreage.upload(
      "school_inventory",
      "inventory_images",
      newFile,
      ""
    );
    setProfileHook(
      `${process.env.REACT_APP_IMAGE_SERVER}fileName:${newName}.png${process.env.REACT_APP_IMAGE_URL}`
    );
  };

  // Handle image upload and close dialog
  const handleUpload = async () => {
    try {
      setLoading(true);
      const response = await fetch(photoURL);
      const blob = await response.blob();
      const file = new File([blob], "image.png", { type: "image/png" });
      setPhotoURL(photoURL);
      setImageFile(file);
      setOpenCrop(false);
      setStatusProgress(true);
      setProgress(10);
      await uploadImage(file);
      setLoading(false);
      // setOpenCrop(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={openCrop}
      fullWidth
      maxWidth="sm"
      className="stu-crop-container"
    >
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography className="dialog-title">Upload Image</Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Button
            onClick={() => {
              setProfileHook("");
              setImageFile("");
              setOpenCrop(false);
            }}
          >
            <CloseIcon className="close-icon" />
          </Button>
        </Box>
      </DialogTitle>

      <DialogContent dividers className="dialog-content-stu-cropp">
        <Stack justifyContent="center" alignItems="center" height="100%">
          <Box
            style={{
              height: "325px",
              width: "525px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <img
              src={photoURL}
              alt="Preview"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ flexDirection: "column", mx: 3, my: 2 }}>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              color: "#f75257",
              borderColor: "#f75257",
              "&:hover": {
                borderColor: "#f75257",
                backgroundColor: "rgba(247, 82, 87, 0.1)",
              },
            }}
            startIcon={<Cancel sx={{ color: "#f75257" }} />}
            onClick={() => {
              // handleClose();
              setProfileHook("");
              setImageFile("");
              setOpenCrop(false);
            }}
          >
            Cancel
          </Button>
          {loading ? (
            <Button variant="contained" disabled>
              Uploading...
            </Button>
          ) : (
            <Button variant="contained" onClick={handleUpload}>
              Upload
            </Button>
          )}
        </Box>
      </DialogActions>
    </Dialog>
  );
}
